<template>
  <v-container
    v-if="dayNotes.length>0"
    :class="['daynote-bar text-center pa-0 ma-0', {'pa-2': !compact}, {'theme--dark': $vuetify.theme.dark}]"
    fluid
  >
    <template v-for="(dn, i) in dayNotes">
      <v-sheet
        :key="i"
        :class="['ma-0 pa-0', {'pa-1': compact}, {'mb-2': !compact && i !== dayNotes.length - 1}]"
        :elevation="compact ? 0 : 2"
        :color="barColor(dn)"
        text
      >
        <v-row
          class="d-flex align-center pa-0 ma-0"
          @click="onEdit(dn)"
        >
          <v-col class="cursor-pointer flex-grow-1 pa-0 ma-0">
            <span :style="`color: ${textColor(dn)}`">{{ dn.text }}</span>
          </v-col>
          <v-col
            class="pa-0 ma-0 mr-1"
            style="min-width:26px;max-width:26px"
            cols="1"
          >
            <v-btn
              class="pa-0 ma-0"
              icon
              small
              :color="textColor(dn)"
              style="opacity: 0.85"
              @click.stop="onDelete(dn)"
            >
              <v-icon>
                mdi-close-box
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-sheet>
    </template>
  </v-container>
</template>

<script lang='ts'>

import Vue, { PropType } from 'vue';
import DayNote from '@/model/DayNote';
import { contrastForColor } from '@/services/color-utils';

export default Vue.extend({
  name: 'DayNoteBar',
  components: { },
  props: {
    compact: { type: Boolean, required: false, default: false },
    onDelete: { type: Function as PropType<((dayNote: DayNote) => void)>, required: true },
    onEdit: { type: Function as PropType<((dayNote: DayNote) => void)>, required: true },
  },
  data() {
    return { };
  },
  computed: {
    dayNotes(): DayNote[] {
      return this.$tstore.getters.dayDayNotes;
    },
  },
  methods: {
    barColor(dn: DayNote): string {
      if (!dn.color) return this.$vuetify.theme.dark ? '#000000' : '#eeeeee';
      return dn.color;
    },
    textColor(dn: DayNote): string {
      return contrastForColor(this.barColor(dn));
    },
  },
});

</script>

<style lang="scss" scoped>
.daynote-bar {

  background-color: $white-color;
  &.theme--dark {
    background-color: $grey-90-color!important;
  }
}
</style>>
